import { toast } from "react-toastify";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _TaxableBase } from "../../../../../../core/services/dataBean/EntityCatalog";
import { useEffect, useState } from "react";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { BasicTable } from "../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../theme/Component/Modal";


interface Props {
    invoice: any;
    _onChange?: Function;
    _returnValue?: Function;
}

export const TaxableBaseUBL = ({ invoice, _onChange, _returnValue }: Props) => {

    const { instance } = useDataBean(_TaxableBase);
    const [originalBean, setOriginalBean] = useState<any>(null);

    const [lista, setLista] = useState<any[]>([]);
    const [bean, setBean] = useState<any>({});

    // const getListaTabla =  useCallback(() => {
    //     if (invoice.IDUBLInvoice) {
    //         if (!invoice.PaymentType) {
    //             getLista()
    //         } else {
    //             if (invoice.PaymentType === 17) {
    //                     getUBLItems();
    //             } else if (invoice.PaymentType === 18) {
    //                 getLista();
    //             }
    //         }
    //     }
    // }, [invoice]);

    useEffect(() => {
        if (invoice.IDUBLInvoice) {
            if (!invoice.PaymentType) {
                getLista()
            } else {
                if (invoice.PaymentType === 17) {
                    getUBLItems();
                } else if (invoice.PaymentType === 18) {
                    getLista();
                }
            }
        }
    }, [invoice])

    const getUBLItems = () => {
        // console.log(invoice.IDUBLInvoice);
        // console.log(invoice.IssueDate);
        instance.getUBLItemsInvoiceValuesByBudget(invoice.IDUBLInvoice, invoice.IssueDate).then(
            (resp) => {
                resp.forEach(element => {
                    element.DataBeanProperties.OBEntity = `${element.DataBeanProperties.OBMnemonic ?? ""} - ${element.DataBeanProperties.OBConsecutive ?? "0"}`
                });
                setLista(resp)
                console.log(resp)
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    const getLista = () => {
        instance.getTaxableAmountForHoldingTax(invoice.IDUBLInvoice, invoice.IssueDate, null).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    const updateValue = (e: any) => {
        if (invoice.PaymentType && e != null) {
            const newBean = { ...e, TaxBase: e.TaxableAmount ?? e.TaxBase ?? 0 };
            if (invoice.PaymentType === 17) {
                _onChange?.(newBean);
            } else if (invoice.PaymentType === 18) {
                _returnValue?.(newBean);
            }
        } else {
            console.log(e);
        }
    };

    const head = [
        { title: 'Tipo Artículo', property: 'ArticleType', visible: true },
        { title: 'Base Impositiva', property: 'TaxableAmount', visible: true, },
        { title: 'Impuesto', property: 'TaxAmount', visible: true },
        { title: 'Total', property: 'TotalItemAmount', visible: true },
        { title: 'Base', property: 'Base', visible: true },
    ]

    const head2 = [
        { title: 'Obligación Presupuestal', property: 'OBEntity', visible: true },
        { title: 'Rubro Presupuestal', property: 'BudgetName', visible: true, },
        { title: 'Recurso Presupuestal', property: 'BudgetResourceName', visible: true },
        { title: 'Fuente de Financiamiento', property: 'BudgetSourceName', visible: true },
        { title: 'Base para Impuestos', property: 'TaxableAmount', visible: true },
    ]

    const [modal, setModal] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar Base', icono: 'ri-edit-2-line', visible: invoice.PaymentType === 17, evento: () => { setModal({ ...modal, "view": true, "name": "Editar Base para Impuesto" }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const setRowBean = (e: any) => {
        setBean(e);
        setOriginalBean({ ...e });
        _onChange?.(e)
    };


    return (
        <div className="row">
            {/* <PrintJson json={lista} /> */}
            {invoice.PaymentType ?
                (
                    <>
                        {invoice.PaymentType === 17 &&
                            <>
                                {/* <PrintJson json={invoice} /> */}
                                <div className="col-12">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <BasicTable listButtons={listaBotones()} body={lista} head={head2} rowSet={setRowBean} />
                                        </div>
                                        {/* <div className="col-md-12 mt-4">
                                            <BasicButton eventClick={() => { _onChange(bean) }} icon="ri-send-plane-line" children={"Seleccionar"} />
                                        </div> */}

                                        <div className="col-md-12">
                                            <Modal modal={modal} updateModal={setModal} eventModal={() => {
                                                const updatedList = lista.map(item => {
                                                    if (JSON.stringify(item.DataBeanProperties) === JSON.stringify(originalBean)) {
                                                        const updatedBean = {
                                                            ...bean,
                                                            TaxBase: bean.TaxableAmount ?? bean.TaxBase ?? 0, // 🔹 sincroniza TaxBase con TaxableAmount
                                                        };

                                                        // 🔹 Devuelve el bean actualizado al padre
                                                        _onChange?.(updatedBean);

                                                        return {
                                                            ...item,
                                                            DataBeanProperties: updatedBean,
                                                            DataBeanName: "com.quickdataerp.bean.ubl.UBLItemInvoice",
                                                        };
                                                    }
                                                    return item;
                                                });

                                                setLista(updatedList);
                                                setModal({ ...modal, view: false });
                                            }}>
                                                <div className="row">
                                                    <div className="col">
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            value={bean.TaxableAmount}
                                                            onChange={(e) => {
                                                                const val = Number(e.target.value);
                                                                setBean(prev => ({ ...prev, TaxableAmount: val }));
                                                            }}
                                                        />

                                                    </div>
                                                </div>
                                            </Modal>
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                        {invoice.PaymentType === 18 &&
                            <div className="col-12">
                                <BasicTable body={lista} head={head} rowSet={setRowBean} _returnCellValue={(e) => { updateValue(e) }} />
                            </div>
                        }

                    </>
                )
                :
                <div className="col-12">
                    <BasicTable body={lista} head={head} rowSet={setRowBean} _returnCellValue={(e) => { _returnValue(e) }} />
                </div>
            }
        </div>
    )
}